// Assign user roles
export * from "./viewRoles.component";



// WEBPACK FOOTER //
// ./src/app/modules/userHome/applications/viewRoles/index.ts